/*
  Add here your own custom javascript codes
*/

/**
 * Product Switcher - Instant Page Loading
 * Detects hover/touch and prefetches the product page before the user clicks.
 */
(function() {
  const prefetchProduct = (e) => {
    const link = e.target.closest('.product-block[data-type="product_switcher"] a');
    
    if (link && link.href && !link.dataset.preloaded) {
      // Create a prefetch link in the document head
      const prefetchTag = document.createElement('link');
      prefetchTag.rel = 'prefetch';
      prefetchTag.href = link.href;
      document.head.appendChild(prefetchTag);
      
      // Mark as preloaded so we don't repeat for the same link
      link.dataset.preloaded = 'true';
    }
  };

  // Listen for mouse hover (desktop) and touch start (mobile)
  document.addEventListener('mouseover', prefetchProduct, { passive: true });
  document.addEventListener('touchstart', prefetchProduct, { passive: true });
})();

